<template>
    <div class="index">
      <div style="height: 120px"></div>
      <div class="main">
        <div class="title">
          <div class="sp1">跨境<span style="color: #F40009">/进出口</span></div>
          <div class="sp2">CROSS BORDER</div>
        </div>
        <div class="content" style="justify-content: space-around;max-width: 1200px;margin: 100px auto 0">

          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/zgzzs.jpg" alt="">
            中国制造商
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/zgws.jpg" alt="">
            中国网商
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/zgxfz.jpg" alt="">
            中国消费者
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/kjdspt.jpg" alt="">
            跨境电商平台
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/wgxfz.jpg" alt="">
            外国消费者
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <img src="@/assets/img/solition/wgws.jpg" alt="">
            外国网商
          </div>
          <div style="display: flex;flex-direction: column;align-items: center">
            <img src="@/assets/img/solition/wgzzs.jpg" alt="">
            外国制造商
          </div>
        </div>
      </div>
      <div class="main">
        <div class="title">
          <div class="sp1">什么是<span style="color: #F40009">ERP</span></div>
          <div class="sp2">ENTERPRISE RESOURCE</div>
        </div>
        <div class="content">
          <div class="left" style="padding-top: 30px;display: flex;flex-direction: row;align-items: center">
            ERP不仅仅是一个软件更重要的是一个管理思想，它实现了企业内部资源和企业相关的外部资源的整合。通过软件把企业的人、财、物、产、供销及相应的物流、信息流、资金流、管理流、增值流等紧密地集成起来实现资源优化和共享。
          </div>
          <img src="@/assets/img/solition/outBoundERP.png" alt="" style="width: 400px;height: 400px">
        </div>
      </div>
      <div class="main">
        <div class="title">
          <div class="sp1">产品<span style="color: #F40009">优势</span></div>
          <div class="sp2">ADVANTAGE</div>
        </div>
        <div class="content" style="flex-direction: column">
          <Row :gutter="16" style="width: 100%" type="flex" justify="center">
            <i-col span="6" >
              <div class="colTable">
                <img src="@/assets/img/solition/zsdzfw.png" alt="">
                <div style="text-align: center">
                  <div style="margin-bottom: 10px">专属定制服务</div>
                  <div>业务量身定制专属ERP，不受ERP产品约束</div>
                </div>
              </div>
            </i-col>
            <i-col span="2">
            </i-col>
            <i-col span="6">
              <div class="colTable">
                <img src="@/assets/img/solition/wsshfw.png" alt="">
                <div style="text-align: center">
                  <div style="margin-bottom: 10px">完善售后服务</div>
                  <div>有专门的的售后团队提供优质的售后服务</div>
                </div>
              </div>
            </i-col>
          </Row>
          <Row :gutter="16" style="width: 100%" type="flex" justify="center">
            <i-col span="6">
              <div class="colTable">
                <img src="@/assets/img/solition/tdfw.png" alt="" style="width: 215px;">
                <div style="text-align: center">
                  <div style="margin-bottom: 10px">IT团队服务</div>
                  <div>不用分心IT团队，可集中精力发展主业</div>
                </div>
              </div>
            </i-col>
            <i-col span="2">
            </i-col>
            <i-col span="6">
              <div class="colTable">
                <img src="@/assets/img/solition/jzxyfw.png" alt="" style="width: 188px;">
                <div style="text-align: center">
                  <div style="margin-bottom: 10px">极致响应服务</div>
                  <div>响应及时，服务及时，不用久等</div>
                </div>
              </div>
            </i-col>
          </Row>
        </div>
      </div>
      <div class="main">
        <div class="title">
          <div class="sp1"><span style="color: #F40009">安全</span>可靠</div>
          <div class="sp2">SECURITY</div>
        </div>
        <div class="dess">5年技术沉淀  成就行业口碑</div>
        <div class="content" style="margin-top: 100px">
          <div class="box3">
            <img class="box3img" src="@/assets/img/solition/kj_images_01.png" alt="">
            <div class="sp1">安全与监控层</div>
            <div class="sp2"><div class="dio"></div></div>
            <div class="sp3">解决业务发展中遇到的大流量网络攻击恶意刷单和活动作弊问题</div>
          </div>
          <div class="box3">
            <img class="box3img" src="@/assets/img/solition/kj_images_02.png" alt="">
            <div class="sp1">弹性计算层</div>
            <div class="sp2"><div class="dio"></div></div>
            <div class="sp3">负载均衡服务消除单点故障保证高并发时系统的健壮性</div>
          </div>
          <div class="box3">
            <img class="box3img" src="@/assets/img/solition/kj_images_03.png" alt="">
            <div class="sp1">数据库层</div>
            <div class="sp2"><div class="dio"></div></div>
            <div class="sp3">结构化数据通过运输局库RDS存储数据单独储存杜绝数据丢失</div>
          </div>
          <div class="box3">
            <img class="box3img" src="@/assets/img/solition/kj_images_04.png" alt="">
            <div class="sp1">分布式服务器</div>
            <div class="sp2"><div class="dio"></div></div>
            <div class="sp3">有效应对典型的大规模高并发访问等电商场景</div>
          </div>
        </div>
      </div>
      <div class="main" v-if="false">
        <div class="title">
          <div class="sp1"><span style="color: #F40009">跨境</span>评价系统</div>
          <div class="sp2">ENTERPRISE RESOURCE</div>
        </div>
        <div class="dess">
          售后延保方式增评，巧妙搜集买家真实邮箱，自动引导买家留评，<br>
          符合亚马逊飞轮理论的增长逻辑，最高有效提升30%留评率
        </div>
        <div class="content" style="top: 340px">
          <div class="col">
            <div class="boxxx">
              <div>身份验证</div>
              <div>买家根据收到的引导卡片来到保修网站，在落地页提交姓名、订单编号、邮箱等信息，进行身份验证，验证成功，则到达激活保修页面，选择对应ASIN进行激活</div>
            </div>
            <div class="boxxx">
              <div>选择礼物</div>
              <div>买家进入礼品选择页面，选择卖家设定好的对应的赠品，并填写收货信息，进入下一步留评动作；也可不选择礼品，直接留评</div>
            </div>
          </div>
          <img src="@/assets/img/solition/appraise.png" alt="" style="width: 347px;height: 690px;display: block;margin: 0 20px">
          <div class="col">
            <div class="boxxx">
              <div>提交评论</div>
              <div>买家选择礼品后，进入留评打分页面引导买家进行星级勾选和内容评价在网页完成留评后，好评会自动复制评价内容并跳转到亚马逊留评页。</div>
            </div>
            <div class="boxxx">
              <div>二次索评</div>
              <div>针对没有留评的买家，卖家可在系统后台查看买家真实邮箱，进行沟通跟进，或通过加大折扣与礼品力度等方式再次引导买家留评</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="title">
          <div class="sp1"><span style="color: #F40009">自建</span>站</div>
          <div class="sp2">SELF BUILT STATION</div>
        </div>
        <div class="content">
          <img src="@/assets/img/solition/team.png" alt="" style="width: 484px;margin-right: 200px">
          <div class="right">
            <div class="boxx">
              <div>提出需求</div>
              <div>客户通过网站/邮件/电话提出项目需求，全面沟通了解项目情况</div>
            </div>
            <div class="boxx">
              <div>后台开发</div>
              <div>搭建系统框架-后台程序编写-功能测试-注入搜索优化-递交客户验收</div>
            </div>
            <div class="boxx">
              <div>创意设计</div>
              <div>页面创意设计-总监审核-递交客户确认-客户意见反馈-修改调整</div>
            </div>
            <div class="boxx">
              <div>测试验收</div>
              <div>项目验收上线-客户支付款项-向客户提交相关源文件</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/23 17:19.
     */

    export default {
        mounted() {
          window.scrollTo(0,0);
        },
        components: {},
        props: {},
        data() {
            return {
            }
        },
        computed: {},
        methods: {

        },
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>

<style lang="less" scoped>
 .index{
   width: 100%;
   min-width: 1920px;
   .main{
     width: 100%;
     /*height: 480px;*/
     margin-bottom: 180px;
     position: relative;
     .title {
       position: relative;
       width: 100%;
       height: 110px;
       text-align: center;

       .sp1 {
         width: 100%;
         text-align: center;
         position: absolute;
         font-size: 34px;
         font-family: Source Han Sans CN;
         font-weight: 300;
         color: #232330;
         bottom: 0;
         z-index: 9;
       }

       .sp2 {
         width: 100%;
         text-align: center;
         position: absolute;
         font-size: 90px;
         font-family: Source Han Sans CN;
         font-weight: 800;
         color: #F6F6F6;
       }
     }
     .dess{
       text-align: center;
       width: 100%;
       font-size: 24px;
       font-family: Source Han Sans CN;
       font-weight: 300;
       color: #333333;
       margin-top: 50px;
     }
     .content {
       width: 100%;
       display: flex;
       flex-direction: row;
       justify-content: center;
       font-size: 22px;
       font-family: Source Han Sans CN;
       font-weight: 400;
       color: #333333;
       margin-top: 100px;
       .colTable{
         height: 300px;
         display: flex;
         flex-direction: column;
         justify-content: space-between;
         align-items: center;
         margin-bottom: 50px;
         div:first-child{
           font-size: 24px;
           font-family: Source Han Sans CN;
           font-weight: 500;
           color: #333333;
         }
         div:last-child{
           font-size: 16px;
           font-family: Source Han Sans CN;
           font-weight: 300;
           color: #282331;
         }
         img{
           width: 200px;
           display: block;
           margin-bottom: 40px;
         }
       }
       .box2Content{
         height: 550px;
         display: flex;
         flex-direction: row;
         justify-content: center;
         align-items: center;
       }
       .box2{
         box-shadow: 0px 0px 10px 0px rgba(35, 35, 48, 0.05);
         cursor: pointer;
         position: relative;
         width: 325px;
         height: 450px;
         .box2img{
           height: 550px;
           display: none;
           position: absolute;
           top: 0;
           left: 0;
           bottom: 0;
           right: 0;
           width: 100%;
         }
         .sp1,.sp2,.sp3,.sp4{
           position: absolute;
           text-align: center;
           width: 100%;
           left: 0;
           color: #382C4D;
         }
         .sp1{
           top: 75px;
           font-size: 80px;
           font-family: Source Han Sans CN;
           font-weight: 800;
           color:#FB8789;
         }
         .sp2{
           top: 237px;
           font-size: 40px;
           font-family: Source Han Sans CN;
           font-weight: 400;
         }
         .sp3{
           top: 303px;
           font-size: 28px;
           font-family: Source Han Sans CN;
           font-weight: 400;
         }
         .sp4{
           top: 394px;
           font-size: 20px;
           font-family: Source Han Sans CN;
           font-weight: 300;
           display: none;
         }
       }
       /*.box2:hover{*/
       /*  height: 550px;*/
       /*  .box2img{*/
       /*    display: block;*/
       /*  }*/
       /*  .sp1,.sp2,.sp3,.sp4{*/
       /*    color: white;*/
       /*  }*/
       /*  .sp4{*/
       /*    display: block;*/
       /*  }*/
       /*}*/
       .box2Active{
         height: 550px;
         .box2img{
           display: block;
         }
         .sp1,.sp2,.sp3,.sp4{
           color: white;
         }
         .sp4{
           display: block;
         }
       }
       .box3{
         width: 310px;
         height: 200px;
         position: relative;
         margin-right: 20px;
         overflow: hidden;
         .box3img{
           position: absolute;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           transition: all .8s ease 0s;
           -webkit-transition: all .8s ease 0s;
           cursor: pointer;
         }
         .sp1,.sp2,.sp3{
           position: absolute;
           color: #ffffff;
           left: 40px;
         }
         .sp1{
           top: 40px;
           font-size: 24px;
           font-family: Source Han Sans CN;
           font-weight: 300;
         }
         .sp2{
           top: 83px;
           width: 149px;
           height: 5px;
           background: #999999;
          .dio{
            width: 40px;
            height: 5px;
            background: #ffffff;
          }
         }
         .sp3{
           top: 125px;
           width: 234px;
           font-size: 16px;
           font-family: Source Han Sans CN;
           font-weight: 300;
         }
       }
       .box3:hover{
         .box3img{
           width: 120%;
           height: 120%;
           top: -10%;
           left: -10%;
         }
       }
       .box3:last-child{
         margin-right: 0;
       }
       .box{
         margin-right: 140px;
       }
       img{
         width: 62px;
         margin-bottom: 12px;
       }
       .left{
         width: 623px;
         font-size: 24px;
         font-family: Source Han Sans CN;
         font-weight: 300;
         color: #333333;
         margin-right: 200px;
       }
       .col{
         display: flex;
         flex-direction: column;
         align-items: flex-start;
       }
       .boxxx{
         width: 457px;
         height: 270px;
         background: #F6F6F6;
         font-size: 20px;
         font-family: Source Han Sans CN;
         font-weight: 300;
         color: #232330;
         padding: 45px 20px 0 20px;
         box-sizing: border-box;
         margin-bottom: 150px;
         display: flex;
         flex-direction: column;
         justify-content: flex-start;
         align-items: flex-start;
         div:first-child{
           font-size: 24px;
           font-family: Source Han Sans CN;
           font-weight: bold;
           margin-bottom: 10px;
         }
       }
       .col {
         .boxxx:last-child{
           margin-bottom: 0!important;
         }
       }
       .right{
         display: flex;
         flex-direction: row;
         flex-wrap: wrap;
         width: 600px;
       }
       .boxx{
         width: 258px;
         margin-right: 72px;
         div:first-child{
           font-size: 24px;
           font-family: Source Han Sans CN;
           font-weight: 400;
           color: #000000;
         }
         div:last-child{
           font-size: 18px;
           font-family: Source Han Sans CN;
           font-weight: 400;
           color: #747474;
           line-height: 40px;
           opacity: 0.8;
         }
       }
       .boxx:nth-child(2n){
         margin-right: 0;
       }
     }
   }
 }
</style>
